// extracted by mini-css-extract-plugin
export default {"container":"Gh2_","datesWrapper":"mchB","date":"wDKS","fetchedDate":"qM2r","titleWrapper":"qN5i","title":"vP7f","icon":"Uu9h","datesWrapperCollapsed":"db_k"};